import * as React from 'react';
import SearchCaseContactItem from './SearchCaseContactItem';
import { get } from '../../../../Services/NetteApiClient';
// @ts-ignore
import styles from './SearchCaseContact.module.scss';
import ScrollContainer from '../../../BaseModule/Components/ScrollContainer/ScrollContainer';
import FlatList from '../../../BaseModule/Components/FlatList/FlatList';
import SearchCaseContactFilter from './SearchCaseContactFilter';
import useFlatData from '../../../BaseModule/Hooks/useFlatData';
import useCaseContacts from '../../Hooks/useCaseContacts';
import SearchCaseContactNoResults from './SearchCaseContactNoResults';

interface Props {
	linkSelect: any;
	patientId: string;
}

const WRAPPER_ID = 'caseContactWrapper';

const SearchCaseContact: React.FC<Props> = ({ linkSelect, patientId }) => {
	const { getFlatWorkplaces, getNextPage, data, isLoading, page, setPage } = useCaseContacts();
	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getFlatWorkplaces,
		{
			data: data?.filterCaseContacts?.data,
			totalPages: data?.filterCaseContacts?.meta?.totalPages,
			page: data?.filterCaseContacts?.meta?.page,
		},
		page,
		setPage,
	);

	const handleSelect = async (workplaceId?: string, workplaceMemberId?: string) => {
		let ajaxLink = linkSelect;

		if (workplaceId) {
			ajaxLink = ajaxLink.replace('=workplaceIdPlaceholder', '=' + workplaceId);
		}
		if (workplaceMemberId) {
			ajaxLink = ajaxLink.replace(
				'=workplaceMemberIdPlaceholder',
				'=' + workplaceMemberId,
			);
		}

		await get(ajaxLink);
	};

	return (
		<div className={styles.wrapper}>
			<SearchCaseContactFilter onFilter={setFilter} />
			{(flatData?.length || 0) < 1 && <SearchCaseContactNoResults/> }
			<ScrollContainer wrapperId={WRAPPER_ID} className={styles.scrollWrapper}>
				<FlatList onRefresh={loadData}
									onLoadMore={getNextPage}
									data={flatData}
									isLoading={isLoading}
									className={styles.flatWrapper}
									hasMoreData={hasMoreData} scrollableTargetId={WRAPPER_ID}
									renderItem={(item) => <SearchCaseContactItem onClick={handleSelect} item={item} patientId={patientId}/>}
				/>
			</ScrollContainer>
		</div>
	);
};

export default SearchCaseContact;
